import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ScrollToTop from "./components/scrollToTop";
import Header from "./components/header";
import Footer from "./components/footer"; 
import Leaderboard from "./pages/LeaderBoard";
import PressKit from "./pages/PressKit";
import Feedback from "./pages/Feedback";
import Download from "./pages/Download";



function App() {
  return (
    <div>
      <ScrollToTop></ScrollToTop>
    <Header></Header>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/press" element={<PressKit />} />
        <Route path="/download" element={<Download />} />
        <Route path="/feedback" element={<Feedback />} />


        <Route path="/*" element={<Home />} />











      </Routes>
    <Footer></Footer>
    </div>
  );
}

export default App;
